// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"667":"f615dec2","910":"3bac95a5","977":"c5dce9b7"}[chunkId] + ".chunk.js";
};